import { ELotStatus, LotStatus } from '@bonhams1793/bonhams-typescript'

import { getTranslate } from '@nx/translations'

import {
  StyledHeading,
  StyledSection,
} from '@web/components/lot/LotsPromo/LotsPromo.styles'
import translate from '@web/components/lot/LotsPromo/LotsPromo.translate.json'
import { useGetTypesenseLots } from '@web/helpers/api'
import { useGetSimilarLots } from '@web/helpers/api/similarLots/useGetSimilarLots'

import { LotsPromoGrid } from './LotsPromoGrid'
import { SimilarLots } from './SimilarLots'

const { text } = getTranslate(translate)

export const LotsPromo = (props: LotsPromoProps) => {
  const similarLots = useGetSimilarLots({
    lotDepartmentCode: props.lotDepartmentCode,
    enabled: props.lotStatus !== LotStatus.new,
  })

  const lotsInAuction = useGetLotsInAuction(props)

  const hasData =
    props.lotStatus === LotStatus.new
      ? lotsInAuction.hits?.length
      : similarLots.data?.length

  return hasData ? (
    <StyledSection background="white" verticalSpacing="top-only">
      <StyledHeading $level={3} as="h2">
        {props.lotStatus === LotStatus.new
          ? text('lotsPromo.title.more_from_this_auction')
          : text('lotsPromo.title.bid_on_these_items')}
      </StyledHeading>

      {props.lotStatus === LotStatus.new ? (
        <LotsPromoGrid
          isNewLot
          isLoading={lotsInAuction.isFetching}
          lots={lotsInAuction.hits}
          event={{
            category: 'Lot Page - Lots In Auction',
          }}
        />
      ) : (
        <SimilarLots
          similarLots={similarLots.data}
          isFetching={similarLots.isFetching}
        />
      )}
    </StyledSection>
  ) : null
}

function useGetLotsInAuction({
  auctionId,
  lotStatus,
  lotNumber,
}: LotsPromoProps) {
  const typesenseLotsInAuction = useGetTypesenseLots({
    filters: {
      auctionId: auctionId.toString(),
      filter_by: `lotNo.number:>${lotNumber}`,
      page: 0,
      per_page: 24,
    },
    enabled: lotStatus === LotStatus.new,
  })

  const isFetching = typesenseLotsInAuction.isFetching

  const hits = typesenseLotsInAuction.data?.pages?.[0]?.hits

  return { isFetching, hits }
}

export interface LotsPromoProps {
  auctionId: number
  lotStatus: ELotStatus
  lotNumber: number
  lotUniqueId: number
  lotDepartmentCode?: string
}
